export type WcsSkeletonAnimation = 'none' | 'glide' | 'pulse';
